export default "__VITE_ASSET__V$vMPmIb__"